export default __webpack_public_path__ + "static/media/logo_home_scrolled.7b0b6049.svg";